/** True when the stored user version matches the disclaimer the server is serving. */
export function disclaimerConsentIsCurrent(storedVersion, serverVersion) {
  const stored = String(storedVersion || "").trim();
  const server = String(serverVersion || "").trim();
  return stored.length > 0 && stored === server;
}

export function storedDisclaimerVersion(user) {
  const value = user?.disclaimer_text_version;
  return typeof value === "string" ? value.trim() : "";
}

/**
 * Checkbox when consent is missing, stale, or a submit just returned
 * disclaimer_required. A stored version hides the box until the GET returns
 * a different version.
 */
export function showDisclaimerCheckbox(input) {
  if (input.forced) return true;
  const stored = String(input.storedVersion || "").trim();
  if (!input.serverLoaded) return stored.length === 0;
  const server = String(input.serverVersion || "").trim();
  if (!server) return stored.length === 0;
  return !disclaimerConsentIsCurrent(stored, server);
}

export function responseErrorCode(error) {
  const data = error?.response?.data;
  if (data?.error?.code) return data.error.code;
  const detail = data?.detail;
  if (detail && typeof detail === "object" && detail.code) return detail.code;
  return "";
}

export function isDisclaimerRequired(error) {
  return error?.response?.status === 409 && responseErrorCode(error) === "disclaimer_required";
}
